import { observable } from 'mobx'
import * as moment from 'moment'

export default class userTimelineStore {
  @observable date = moment().format('l')
  @observable data = []
  @observable rawData = []
}



// WEBPACK FOOTER //
// ./src/stores/userTimelineStore.js